<section class="signin-section" >
    <header class="row page-header margin-0">
        <div class="container">
            <div class="row">
                <div class="col-md-6" *ngIf="!emailSent">
                    <h2 class="title">PASSWORD RESET</h2>
                    <p class="hint">Enter your email and click submit to request a password reset.</p>
                </div>
                <div class="col-md-6" *ngIf="emailSent">
                    <h2 class="title">PASSWORD RESET - EMAIL SENT</h2>
                </div>
            </div>
        </div>
    </header>
    <main>
        <form [formGroup]="form" *ngIf="!emailSent">
            <div class="form-section">
                <div class="container">
                    <div class="form-section-container">
                        <div class="row top-buffer-20">
                            <div class="col-md-2">
                                <label for="email">Email</label>
                            </div>
                            <div class="col-md-5">
                                <input type="email" class="form-control" formControlName="email" placeholder="Email" maxlength="50" required />
                                <sp-field-error [controlName]="'Email'" [control]="form?.controls?.email"></sp-field-error>
                            </div>
                        </div>
                        <div class="row top-buffer-20">
                            <div class="col-md-2 offset-md-2">
                                <button [disabled]="!form?.valid || isSubmitting" type="submit" (click)="onSubmitResetPasswordRequest()" class="btn btn-success"
                                        [ngClass]="{'small-pad': isSubmitting }">
                                    <span *ngIf="isSubmitting" class="sp-icon-loader-button-secondary u-alignMiddle"></span>{{isSubmitting? 'Submitting...': 'Submit'}}
                                </button>
                            </div>
                            <div class="col-md-4">
                                <label>
                                    <a [routerLink]="['/signin']" class="reset-button">Back to Sign In</a>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="container" *ngIf="emailSent">
            <div class="row top-buffer-20">
                <div class="col-md-12">
                    <p>
                        If the email address you specified was located in our system, a password reset email has been sent.
                        <br/><br/>
                        Please follow the instructions in the email to reset your password.
                    </p>
                </div>
            </div>
        </div>
    </main>
</section>
